export default "__VITE_ASSET__a7c981de__"